// Role page v2 content (wave 1). First GENERATED Sep 23 2026 by Maeve's gen_v2.py; since Oct 2026 edited in place
// (breadth pass Oct 23 2026: audience cards, 5th prompt, 3 FAQs). Keep FAQ = visible list (FAQPage JSON-LD).
/* eslint-disable */
const content = {
 "slug": "ai-social-media-manager",
 "roleDisplay": "AI Social Media Manager",
 "phrase": "ai social media manager",
 "seo": {
  "title": "AI Social Media Manager: Plans, Writes, Designs | CellCog",
  "description": "An AI social media manager that plans your calendar, writes posts for each platform, makes the images and videos, and posts only what you approve."
 },
 "painSub": "Most small teams don't fail at social media. They fall behind, because it's one more job nobody has time for. Your AI social media manager keeps the calendar full and every post on brand, and nothing goes out until you approve it.",
 "definition": "An AI social media manager is an AI employee that plans your content calendar, writes posts for each platform, makes the images and videos, and publishes only what you approve. On CellCog they are hired in minutes, with their own computer, inbox and task board, and research trends with the agent ranked #1 on DeepResearch Bench (October 2026).",
 "panes": [
  {
   "num": "01 · PLANS THE MONTH",
   "title": "Plans the month.",
   "sub": "A month of posts across your platforms, with dates, formats and captions, from one message.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--calendar\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Content calendar</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>October 2026</b><span>22 posts, each with its caption</span></div><div class=\"rf-legend\"><span class=\"rf-leg rf-tone-blue\"><i></i>LinkedIn</span><span class=\"rf-leg rf-tone-gold\"><i></i>Instagram</span><span class=\"rf-leg rf-tone-orange\"><i></i>Facebook</span><span class=\"rf-leg rf-tone-pink\"><i></i>TikTok</span><span class=\"rf-leg rf-tone-graphite\"><i></i>X</span></div><div class=\"rf-mgrid\"><span class=\"rf-wd\">Mon</span><span class=\"rf-wd\">Tue</span><span class=\"rf-wd\">Wed</span><span class=\"rf-wd\">Thu</span><span class=\"rf-wd\">Fri</span><span class=\"rf-wd\">Sat</span><span class=\"rf-wd\">Sun</span><div class=\"rf-mday out\"><span class=\"rf-dnum\">28</span></div><div class=\"rf-mday out\"><span class=\"rf-dnum\">29</span></div><div class=\"rf-mday out\"><span class=\"rf-dnum\">30</span></div><div class=\"rf-mday has-post rf-tone-gold\"><span class=\"rf-dnum\">1</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Autumn scent drop</span></span></div><div class=\"rf-mday has-post rf-tone-blue\"><span class=\"rf-dnum\">2</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Behind the pour</span></span></div><div class=\"rf-mday wknd\"><span class=\"rf-dnum\">3</span></div><div class=\"rf-mday wknd\"><span class=\"rf-dnum\">4</span></div><div class=\"rf-mday has-post rf-tone-pink\"><span class=\"rf-dnum\">5</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Wick trimming tip</span></span></div><div class=\"rf-mday has-post rf-tone-gold\"><span class=\"rf-dnum\">6</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Reel: first light</span></span></div><div class=\"rf-mday has-post rf-tone-blue\"><span class=\"rf-dnum\">7</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Wholesale is open</span></span></div><div class=\"rf-mday has-post rf-tone-orange\"><span class=\"rf-dnum\">8</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Customer shelfie</span></span></div><div class=\"rf-mday has-post rf-tone-orange\"><span class=\"rf-dnum\">9</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Market stall Sat</span></span></div><div class=\"rf-mday wknd\"><span class=\"rf-dnum\">10</span></div><div class=\"rf-mday wknd\"><span class=\"rf-dnum\">11</span></div><div class=\"rf-mday has-post rf-tone-gold\"><span class=\"rf-dnum\">12</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Scent notes carousel</span></span></div><div class=\"rf-mday has-post rf-tone-blue\"><span class=\"rf-dnum\">13</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Why soy wax</span></span></div><div class=\"rf-mday has-post rf-tone-graphite\"><span class=\"rf-dnum\">14</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Poll: next scent</span></span></div><div class=\"rf-mday has-post rf-tone-pink\"><span class=\"rf-dnum\">15</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Cutting wicks</span></span></div><div class=\"rf-mday has-post rf-tone-orange\"><span class=\"rf-dnum\">16</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Maker spotlight</span></span></div><div class=\"rf-mday wknd\"><span class=\"rf-dnum\">17</span></div><div class=\"rf-mday wknd\"><span class=\"rf-dnum\">18</span></div><div class=\"rf-mday has-post rf-tone-gold\"><span class=\"rf-dnum\">19</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Gift set preview</span></span></div><div class=\"rf-mday has-post rf-tone-graphite\"><span class=\"rf-dnum\">20</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Shipping cutoff</span></span></div><div class=\"rf-mday has-post rf-tone-blue\"><span class=\"rf-dnum\">21</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">A year in candles</span></span></div><div class=\"rf-mday has-post rf-tone-pink\"><span class=\"rf-dnum\">22</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Packing day</span></span></div><div class=\"rf-mday has-post rf-tone-orange\"><span class=\"rf-dnum\">23</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Giveaway</span></span></div><div class=\"rf-mday wknd\"><span class=\"rf-dnum\">24</span></div><div class=\"rf-mday wknd\"><span class=\"rf-dnum\">25</span></div><div class=\"rf-mday has-post rf-tone-blue\"><span class=\"rf-dnum\">26</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Holiday wholesale</span></span></div><div class=\"rf-mday has-post rf-tone-pink\"><span class=\"rf-dnum\">27</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Scent quiz</span></span></div><div class=\"rf-mday has-post rf-tone-gold\"><span class=\"rf-dnum\">28</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Last call: Ember</span></span></div><div class=\"rf-mday has-post rf-tone-gold\"><span class=\"rf-dnum\">29</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Reel: candle care</span></span></div><div class=\"rf-mday has-post rf-tone-blue\"><span class=\"rf-dnum\">30</span><span class=\"rf-mchip\"><span class=\"rf-mchip-t\">Month recap</span></span></div><div class=\"rf-mday wknd\"><span class=\"rf-dnum\">31</span></div><div class=\"rf-mday out\"><span class=\"rf-dnum\">1</span></div></div><div class=\"rf-sched\"><div class=\"rf-sched-wk\">Oct 1 to 4</div><ul class=\"rf-sched-list\"><li class=\"rf-sched-row rf-tone-gold\"><span class=\"rf-sched-d\"><b>1</b>Thu</span><span class=\"rf-sched-t\">Autumn scent drop</span><span class=\"rf-sched-c\">Instagram</span></li><li class=\"rf-sched-row rf-tone-blue\"><span class=\"rf-sched-d\"><b>2</b>Fri</span><span class=\"rf-sched-t\">Behind the pour</span><span class=\"rf-sched-c\">LinkedIn</span></li></ul><div class=\"rf-sched-wk\">Oct 5 to 11</div><ul class=\"rf-sched-list\"><li class=\"rf-sched-row rf-tone-pink\"><span class=\"rf-sched-d\"><b>5</b>Mon</span><span class=\"rf-sched-t\">Wick trimming tip</span><span class=\"rf-sched-c\">TikTok</span></li><li class=\"rf-sched-row rf-tone-gold\"><span class=\"rf-sched-d\"><b>6</b>Tue</span><span class=\"rf-sched-t\">Reel: first light</span><span class=\"rf-sched-c\">Instagram</span></li><li class=\"rf-sched-row rf-tone-blue\"><span class=\"rf-sched-d\"><b>7</b>Wed</span><span class=\"rf-sched-t\">Wholesale is open</span><span class=\"rf-sched-c\">LinkedIn</span></li><li class=\"rf-sched-row rf-tone-orange\"><span class=\"rf-sched-d\"><b>8</b>Thu</span><span class=\"rf-sched-t\">Customer shelfie</span><span class=\"rf-sched-c\">Facebook</span></li><li class=\"rf-sched-row rf-tone-orange\"><span class=\"rf-sched-d\"><b>9</b>Fri</span><span class=\"rf-sched-t\">Market stall Sat</span><span class=\"rf-sched-c\">Facebook</span></li></ul><p class=\"rf-sched-more\">and 15 more this month</p></div></div></div></div>"
  },
  {
   "num": "02 · WRITES EVERY POST",
   "title": "Writes every post, per channel.",
   "sub": "One idea written for each channel, in the length and tone that channel expects.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--drafts\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Drafts</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>Ember is back</b><span>One idea, four channels</span></div><div class=\"rf-drafts\"><div class=\"rf-draft\"><div class=\"rf-dr-h\"><img src=\"https://cellcog.ai/assets/icons/connectors/linkedin.svg\" alt=\"\" width=\"16\" height=\"16\"><span>LinkedIn</span></div><p>We poured 1,100 test candles before we settled on one wick. What slow testing taught a tiny studio about returns.</p></div><div class=\"rf-draft\"><div class=\"rf-dr-h\"><img src=\"https://logos.composio.dev/api/instagram\" alt=\"\" width=\"16\" height=\"16\"><span>Instagram</span></div><p>Ember is back for autumn. Smoked cedar, black tea and a little orange peel. Swipe to watch the pour. Link in bio.</p></div><div class=\"rf-draft\"><div class=\"rf-dr-h\"><img src=\"https://cellcog.ai/assets/icons/connectors/twitter.svg\" alt=\"\" width=\"16\" height=\"16\"><span>X</span></div><p>1,100 test candles. One wick. Returns down to almost zero. Slow testing is the whole secret.</p></div><div class=\"rf-draft\"><div class=\"rf-dr-h\"><span>Email newsletter</span><em>To: 2,400 subscribers</em></div><b class=\"rf-dr-s\">Ember is back</b><p>The scent you asked for all summer is back. Subscribers get first pick on Thursday.</p></div></div></div></div></div>"
  },
  {
   "num": "03 · BRAND MEMORY",
   "title": "Remembers your brand.",
   "sub": "Your brand guide, past posts and product shots live in your Drive. Every post follows them.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--drive\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Drive</span></div><div class=\"rf-body\"><div class=\"rf-drive\"><div class=\"rf-crumb\"><span>Drive</span><i aria-hidden=\"true\">/</i><span>Fernbrook Candle</span><i aria-hidden=\"true\">/</i><b>Brand</b></div><ul class=\"rf-files\"><li class=\"rf-file\"><span class=\"rf-ficon rf-t-pdf\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">PDF file</span></span><span class=\"rf-fname\">Brand voice guide.pdf</span><span class=\"rf-fmeta\">Tone, words we avoid</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-dir\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z\"/></svg><span class=\"rf-sr\">Folder</span></span><span class=\"rf-fname\">Past posts</span><span class=\"rf-fmeta\">52 posts they learned from</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-img\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><circle cx=\"10\" cy=\"12\" r=\"2\"/><path d=\"m20 17-1.09-1.09a2 2 0 0 0-2.82 0L10 22\"/></svg><span class=\"rf-sr\">Image</span></span><span class=\"rf-fname\">Product photos</span><span class=\"rf-fmeta\">36 files</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-doc\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">Document</span></span><span class=\"rf-fname\">Scent names and stories.docx</span><span class=\"rf-fmeta\">Added by you</span></li></ul><div class=\"rf-remember\"><b>Remembered</b><p>Short captions, no exclamation marks, and every post credits the pourer.</p></div></div></div></div></div>"
  },
  {
   "num": "04 · APPROVALS",
   "title": "Asks before anything goes out.",
   "sub": "Every post waits for your yes. Approve, edit or skip in one tap.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--approval\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Approvals</span></div><div class=\"rf-body\"><div class=\"rf-appr\"><div class=\"rf-appr-card\"><span class=\"rf-appr-h\"><i aria-hidden=\"true\"></i>Waiting for your yes</span><p class=\"rf-appr-q\">Post the Ember carousel to Instagram, Thu 9:00?</p><div class=\"rf-prev\"><div class=\"rf-prev-h\"><img src=\"https://logos.composio.dev/api/instagram\" alt=\"\" width=\"16\" height=\"16\"><span>Instagram</span><em>Fernbrook Candle</em></div><b class=\"rf-prev-t\">Ember is back for autumn</b><p class=\"rf-prev-b\">Smoked cedar, black tea and a little orange peel. Swipe to watch the pour. Link in bio.</p></div><div class=\"rf-appr-b\"><span class=\"rf-btn-y\">Approve</span><span class=\"rf-btn\">Edit</span><span class=\"rf-btn\">Skip</span></div></div><div class=\"rf-queue\"><span class=\"rf-queue-h\">2 more waiting</span><ul><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">LinkedIn post: what 1,100 test candles taught us</span><span class=\"rf-q-m\">LinkedIn · Fri 8:30</span></li><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Reply to a comment about shipping times</span><span class=\"rf-q-m\">Instagram · drafted</span></li></ul></div></div></div></div></div>"
  },
  {
   "num": "05 · REPORTS BACK",
   "title": "Reports back.",
   "sub": "A short report in your inbox: what is done, what is next, what needs you.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--report\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">End of day report</span></div><div class=\"rf-body\"><div class=\"rf-report\"><div class=\"rf-rep-h\"><b>Fernbrook social</b><span>Today, 5:55 pm</span></div><div class=\"rf-stats\"><div class=\"rf-stat\"><b>4</b><span>posts scheduled</span></div><div class=\"rf-stat\"><b>18</b><span>comments answered</span></div><div class=\"rf-stat\"><b>2</b><span>reels made</span></div></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--done\">Done</span><ul><li>Scheduled 4 posts for next week</li><li>Answered 18 comments in your voice</li><li>Made the Ember reel and the scent carousel</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--next\">Next</span><ul><li>Draft November themes</li><li>Test a Thursday morning slot</li><li>Plan the gift set launch posts</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--need\">Needs you</span><ul><li>Approve 3 posts for next week</li></ul></div></div></div></div></div>"
  }
 ],
 "capabilities": [
  {
   "title": "Plans your calendar",
   "body": "A month of posts across platforms, with dates, formats and captions, from one message."
  },
  {
   "title": "Writes for each platform",
   "body": "The same idea as a LinkedIn post, an Instagram caption and a short X post, each in its own voice."
  },
  {
   "title": "Makes images and short videos",
   "body": "Carousels, product shots and vertical videos in your colors, made alongside the copy."
  },
  {
   "title": "Watches trends in your niche",
   "body": "Checks what is working this week and suggests posts that fit your brand."
  },
  {
   "title": "Keeps the feed consistent",
   "body": "Learns your voice and brand rules from examples and keeps every post on them."
  },
  {
   "title": "Repurposes what you have",
   "body": "Turns a blog post, video or launch note into a week of posts across formats."
  }
 ],
 "steps": [
  {
   "n": "01",
   "title": "Hire in one line.",
   "body": "\"Hire a social media manager for our candle brand. We post on Instagram and LinkedIn.\""
  },
  {
   "n": "02",
   "title": "Connect your accounts.",
   "body": "Add LinkedIn or X, and your Drive for brand assets. You choose what they can touch."
  },
  {
   "n": "03",
   "title": "Approve the first week.",
   "body": "They send a calendar and drafts. You approve, edit or skip each one."
  }
 ],
 "tools": [
  {
   "name": "LinkedIn",
   "logo": "https://logos.composio.dev/api/linkedin"
  },
  {
   "name": "X",
   "logo": "https://logos.composio.dev/api/twitter"
  },
  {
   "name": "Instagram",
   "logo": "https://logos.composio.dev/api/instagram"
  },
  {
   "name": "Facebook",
   "logo": "https://logos.composio.dev/api/facebook"
  },
  {
   "name": "YouTube",
   "logo": "https://logos.composio.dev/api/youtube"
  },
  {
   "name": "Canva",
   "logo": "https://logos.composio.dev/api/canva"
  },
  {
   "name": "Google Drive",
   "logo": "https://logos.composio.dev/api/googledrive"
  },
  {
   "name": "Buffer",
   "logo": "https://logos.composio.dev/api/buffer"
  }
 ],
 "control": {
  "statement": "Nothing goes out without your yes.",
  "sub": "They do the work.",
  "accent": "You decide what gets published.",
  "rows": [
   {
    "title": "Drafts first, posts on your approval",
    "body": "Every post waits for your yes by default."
   },
   {
    "title": "You set what they may do alone",
    "body": "Allow scheduled posts on one platform and keep the rest on approval."
   },
   {
    "title": "Everything visible",
    "body": "Every draft, post and task sits on one board you can read any time."
   }
  ]
 },
 "wont": {
  "sub": "They run your social media.",
  "accent": "Some things stay off limits.",
  "rows": [
   {
    "title": "No paid ads or spending",
    "body": "They won't run ads, boost posts or spend your money."
   },
   {
    "title": "No promised reach",
    "body": "They won't promise followers, reach or virality."
   },
   {
    "title": "Only where AI posts are welcome",
    "body": "They won't post without your approval, or to communities whose rules ban AI-written content, like Reddit."
   }
  ]
 },
 "comparison": {
  "title": "Three ways to run your social media",
  "cols": [
   "Doing it yourself",
   "A scheduling tool",
   "AI Social Media Manager"
  ],
  "rows": [
   {
    "label": "Plans the calendar",
    "cells": [
     "You, every week",
     "You plan, it queues",
     "Plans it, you approve"
    ]
   },
   {
    "label": "Writes each post per platform",
    "cells": [
     "You",
     "You",
     "Yes, per platform"
    ]
   },
   {
    "label": "Makes images and short videos",
    "cells": [
     "You, or a designer",
     "No",
     "Yes"
    ]
   },
   {
    "label": "Watches trends in your niche",
    "cells": [
     "When you find time",
     "Basic analytics",
     "Every week, with suggestions"
    ]
   },
   {
    "label": "Posts on schedule",
    "cells": [
     "You remember",
     "Yes",
     "Yes, after your approval"
    ]
   },
   {
    "label": "Asks before anything goes out",
    "cells": [
     "n/a",
     "No",
     "Yes, by default"
    ]
   }
  ]
 },
 "prompts": [
  {
   "q": "Plan a month of social content for our candle brand: 20 posts, a caption for each, and five images.",
   "deliverable": "a content calendar, 20 captions, 5 images"
  },
  {
   "q": "Turn this blog post into a week of posts for LinkedIn, Instagram and X.",
   "deliverable": "a week of platform-tuned posts"
  },
  {
   "q": "Make three short vertical videos teasing our new autumn scent, with a punchy script.",
   "deliverable": "three short videos with scripts"
  },
  {
   "q": "What is working for small candle brands on Instagram this month? Suggest five posts that fit us.",
   "deliverable": "a trend note with five post ideas"
  },
  {
   "q": "We are opening a second location next month. Plan two weeks of posts that build up to opening day, with images.",
   "deliverable": "a two-week launch plan with posts and images"
  }
 ],
 "faq": [
  {
   "q": "What is an AI social media manager?",
   "a": "An AI employee that plans your content calendar, writes posts for each platform, makes the images and videos, and publishes only what you approve."
  },
  {
   "q": "Can they post for me?",
   "a": "Yes, on LinkedIn, X, Facebook Pages, YouTube and Instagram Business accounts, once you connect them. By default every post waits for your approval. You can also approve a kind of post in advance, like up to two LinkedIn posts a week, and they post those on their own."
  },
  {
   "q": "Do they work with a personal Instagram account?",
   "a": "Not for posting. Instagram only allows publishing from Business or Creator accounts. Your AI social media manager can still write the captions and make the images for you to post."
  },
  {
   "q": "Can they make images and videos, not just captions?",
   "a": "Yes, they generate on-brand images and short videos alongside the copy, so a single request can return a full week of ready-to-post content."
  },
  {
   "q": "Will the posts actually fit each platform?",
   "a": "Your AI social media manager tunes tone and format for each platform when you tell them where the post is going. You review before posting, so platform fit stays under your eye."
  },
  {
   "q": "How do they learn my brand voice?",
   "a": "Give your AI social media assistant past posts, your brand colors and a few examples you like. Your AI social media assistant keeps every post on them, and you can correct your assistant in one message."
  },
  {
   "q": "Is an AI social media manager a good fit for a small business?",
   "a": "Yes. An AI social media manager suits owners who know they should post more but never find the time. Tell your AI social media manager about your business once, connect your accounts, and approve a week of posts in one sitting."
  },
  {
   "q": "How are they different from AI social media manager tools that schedule posts?",
   "a": "Most tools queue posts you already wrote. Your AI social media manager plans the calendar, writes and designs each post, watches what works in your niche and reports back. You still approve what goes out."
  },
  {
   "q": "Can I try an AI social media manager for free?",
   "a": "Yes. Every new account gets 200 free credits, and no credit card is needed to sign up. Use them to hire your AI social media manager and try a first task."
  },
  {
   "q": "What does an AI social media manager cost?",
   "a": "__COST_FAQ__"
  },
  {
   "q": "How do I get started?",
   "a": "Click \"Get started\" to sign up and hire one in minutes, or use \"Talk to us\" and our team will help you set them up."
  }
 ],
 "ctaBand": {
  "title": "Put your AI Social Media Manager to work today",
  "body": "Send them one line about your brand and get back a month of posts to approve."
 },
 "audience": {
  "title": "Who hires an AI social media manager",
  "cards": [
   {
    "badge": "Solo founders",
    "title": "A feed that keeps going",
    "body": "Founders hand off planning and drafting, and approve a week of posts in one sitting instead of writing them at night."
   },
   {
    "badge": "Small businesses",
    "title": "Posting without the weekly scramble",
    "body": "Shops, studios and local brands get a month of posts planned and drafted, and approve them in a few minutes a week."
   },
   {
    "badge": "Mid-size companies",
    "title": "One calendar across every channel",
    "body": "Marketing teams give your AI social media manager the brand guide and the launch plan. Your AI social media manager drafts for each channel, and everyone you give access can review."
   },
   {
    "badge": "Agencies",
    "title": "One social media manager AI per client",
    "body": "Hire one per client. Each keeps their own brand memory, calendar and approvals, so voices never mix."
   },
   {
    "badge": "Restaurants and cafes",
    "title": "A menu that shows up in the feed",
    "body": "New dishes, events and opening hours turned into posts and short videos for Instagram and Facebook, ready to approve."
   },
   {
    "badge": "E-commerce brands",
    "title": "Launches that show up everywhere",
    "body": "New products, drops and sales turned into posts, carousels and short videos with your product shots."
   }
  ]
 }
};

export default content;
